import { StoryFrame } from '../Entities/Case';
import ContentfulStory from '../Entities/Contentful/ContentfulStory';

export default (node: ContentfulStory): StoryFrame => {
  return {
    description: node.description ? node.description.childMarkdownRemark.html : undefined,
    id: node.id,
    image: {
      alt: node.media.file.fileName,
      src: node.media.sizes.src,
      srcSet: node.media.sizes.srcSet
    },
    title: node.title
  };
};



// WEBPACK FOOTER //
// ./src/utils/mapStoryFrame.ts